// InfoButton - Reusable info icon with tooltip
import { useState, useRef, useEffect } from 'preact/hooks'

export default function InfoButton({ title, children, position = 'bottom' }) {
  const [showTooltip, setShowTooltip] = useState(false)
  const tooltipRef = useRef(null)
  const buttonRef = useRef(null)

  // Close tooltip when clicking outside
  useEffect(() => {
    if (!showTooltip) return

    const handleClickOutside = (e) => {
      if (
        tooltipRef.current && 
        !tooltipRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setShowTooltip(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showTooltip])

  return (
    <div className="info-button-container">
      <button
        ref={buttonRef}
        className="info-button"
        onClick={(e) => {
          e.stopPropagation()
          setShowTooltip(!showTooltip)
        }}
        title="Show information"
        type="button"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </button>
      
      {showTooltip && (
        <div 
          ref={tooltipRef}
          className={`info-tooltip info-tooltip-${position}`}
        >
          {title && <div className="info-tooltip-title">{title}</div>}
          <div className="info-tooltip-content">
            {children}
          </div>
        </div>
      )}
    </div>
  )
}
